import React from 'react';
import { getCmsImagePath } from '../cms/cmsData';

const TornPaperWrapper = ({ children }) => {
  return (
    <div className="torn-paper-wrapper">
      <img loading="lazy" src={getCmsImagePath('paperTornTop', '/paper-torn-top.webp')} alt="torn paper top" className="torn-paper-top" />
      <div className="torn-paper-card">
        {children}
      </div>
      <img loading="lazy" src={getCmsImagePath('paperTornBottom', '/paper-torn-bottom.webp')} alt="torn paper bottom" className="torn-paper-bottom" />
    </div>
  );
};

export default TornPaperWrapper;
